import React from "react";

export const WizeCareWhiteLogo = () => {
  const fillWhite = {
    fill: "#fff",
  };
  return (
    <svg id="Layer_1" width="94.175" height="15.81" viewBox="0 0 94.175 15.81">
      <path
        id="Path_15"
        d="M759.851 858.449a2.928 2.928 0 0 0 5.857 0v-6.806a1.014 1.014 0 0 1 1.012-1.013h.023a.938.938 0 0 1 .7.3.969.969 0 0 1 .3.716v6.806a2.934 2.934 0 0 0 5.869 0v-9.832a.979.979 0 0 1 .3-.716.94.94 0 0 1 .705-.3h.023a.971.971 0 0 1 .715.3.99.99 0 0 1 .286.716v9.832a4.961 4.961 0 0 1-4.965 4.966 4.97 4.97 0 0 0-7.894 0 4.963 4.963 0 0 1-4.965-4.966v-3.817a.974.974 0 0 1 .3-.716.964.964 0 0 1 .7-.3h.033a1.014 1.014 0 0 1 1 1.013z"
        style={fillWhite}
        transform="translate(-757.814 -847.605)"
      />
      <path
        id="Path_16"
        d="M831.875 857.965a.936.936 0 0 1 .7.3.974.974 0 0 1 .3.716v10.769a1.019 1.019 0 0 1-1 1h-.022a.979.979 0 0 1-.716-.3.942.942 0 0 1-.3-.7v-10.772a1.014 1.014 0 0 1 1.013-1.012z"
        style={fillWhite}
        transform="translate(-809.513 -854.939)"
      />
      <path
        id="Path_17"
        d="M854.275 862.638c.082-.088.059-.136-.066-.143h-5.658a.941.941 0 0 1-.705-.3.961.961 0 0 1-.3-.7v-.033a.961.961 0 0 1 .3-.7.942.942 0 0 1 .705-.3h6.617a1.693 1.693 0 0 1 1.232 2.9q-3.732 3.919-6.561 6.88c0 .008-.017.03-.055.066q-.132.132.055.144h.077l6.066.01a.96.96 0 0 1 .705.286.978.978 0 0 1 .3.715v.023a.98.98 0 0 1-.3.715.958.958 0 0 1-.705.286h-7.1a1.693 1.693 0 0 1-1.233-2.895q1.08-1.124 3.281-3.436l3.281-3.446c-.002-.01.02-.035.064-.072z"
        style={fillWhite}
        transform="translate(-821.04 -856.704)"
      />
      <path
        id="Path_18"
        d="M897.3 864.085a.992.992 0 0 1-.5 1.332l-4.052 1.828-4.04 1.828a3.779 3.779 0 0 0 3.127 1.519 3.979 3.979 0 0 0 3.754-2.676.943.943 0 0 1 .97-.682.966.966 0 0 1 .825.429.944.944 0 0 1 .12.913 5.777 5.777 0 0 1-2.158 2.884 5.863 5.863 0 0 1-3.511 1.135 6.012 6.012 0 1 1 3.281-11.043 5.875 5.875 0 0 1 2.184 2.533zm-5.46-1.453a3.967 3.967 0 0 0-3.975 3.986 3.743 3.743 0 0 0 .045.583l6.968-3.149a3.785 3.785 0 0 0-3.041-1.42z"
        style={fillWhite}
        transform="translate(-848.44 -856.786)"
      />
      <path
        id="Path_19"
        d="M977.528 862.334a5.789 5.789 0 0 1 1.76 4.249v5.009a.936.936 0 0 1-.3.7.967.967 0 0 1-.705.3h-.033a.965.965 0 0 1-.7-.3.937.937 0 0 1-.3-.7v-.507a6.008 6.008 0 1 1 .275-8.752zm-7.068 1.443a3.981 3.981 0 1 0 5.625 0 3.972 3.972 0 0 0-5.625 0z"
        style={fillWhite}
        transform="translate(-906.097 -856.786)"
      />
      <path
        id="Path_20"
        d="M1023.4 860.573a.975.975 0 0 1 .716.3.992.992 0 0 1 .286.715v.022a.956.956 0 0 1-.286.7.975.975 0 0 1-.716.3h-.628a2.4 2.4 0 0 0-1.762.726 2.454 2.454 0 0 0-.725 1.761v6.5a.939.939 0 0 1-.3.7.967.967 0 0 1-.706.3h-.032a.965.965 0 0 1-.705-.3.937.937 0 0 1-.3-.7v-6.5a4.482 4.482 0 0 1 1.32-3.2 4.364 4.364 0 0 1 3.2-1.321z"
        style={fillWhite}
        transform="translate(-942.186 -856.786)"
      />
      <path
        id="Path_21"
        d="M1051.53 864.085a.99.99 0 0 1-.5 1.332q-1.541.694-4.051 1.828l-4.04 1.828a3.78 3.78 0 0 0 3.127 1.519 3.976 3.976 0 0 0 3.754-2.676.944.944 0 0 1 .969-.682.967.967 0 0 1 .826.429.949.949 0 0 1 .12.913 5.789 5.789 0 0 1-2.158 2.884 5.865 5.865 0 0 1-3.512 1.135 6.012 6.012 0 1 1 3.28-11.043 5.863 5.863 0 0 1 2.185 2.533zm-5.46-1.453a3.966 3.966 0 0 0-3.975 3.986 3.781 3.781 0 0 0 .045.583l6.969-3.149a3.787 3.787 0 0 0-3.039-1.42z"
        style={fillWhite}
        transform="translate(-957.63 -856.786)"
      />
      <path
        id="Path_22"
        d="M941.745 860.859a.919.919 0 0 1 .7.958v.055a.942.942 0 0 1-.407.8.955.955 0 0 1-.9.154 3.751 3.751 0 0 0-1.211-.2 3.98 3.98 0 1 0 0 7.96 3.912 3.912 0 0 0 1.211-.188.975.975 0 0 1 .9.144.953.953 0 0 1 .407.815.929.929 0 0 1-.7.957 6.037 6.037 0 0 1-1.817.276 6.012 6.012 0 1 1 1.817-11.737z"
        style={fillWhite}
        transform="translate(-882.487 -856.786)"
      />
    </svg>
  );
};

export const AppleStoreIcon = () => {
  const cls1 = { fill: "#fefefe" };
  const cls2 = { fill: "#010101" };
  const cls3 = { fill: "#020202" };
  const cls4 = { fill: "#030303" };
  const cls6 = { fill: "#fdfdfd" };

  return (
    <svg width="298.047" height="91.751" viewBox="0 0 298.047 91.751">
      <g id="Group_7943" transform="translate(-.001 -.001)">
        <g id="Group_7942" transform="translate(.001 .001)">
          <path
            id="Path_3625"
            d="M432.9 272.067h132.391c9.741 0 16.673 6.924 16.673 16.653v58.713a16.142 16.142 0 0 1-16.293 16.339q-132.671 0-265.341.045c-8.483.007-16.506-7.184-16.409-16.456.207-19.631.06-39.266.064-58.9a15.958 15.958 0 0 1 16.338-16.394q66.286-.003 132.577 0z"
            style={cls1}
            transform="translate(-283.918 -272.067)"
          />
          <path
            id="Path_3626"
            d="M362.147 379.508a10.528 10.528 0 0 1-4.773-1.116 13.56 13.56 0 0 0-11.423.119 12.6 12.6 0 0 1-3.774 1.016c-3.4.363-5.645-1.578-7.605-3.867a38.563 38.563 0 0 1-7.3-12.536c-2.357-6.836-3.439-13.77-.7-20.772a15.41 15.41 0 0 1 11.509-9.972 14.025 14.025 0 0 1 8.216 1.028c.769.3 1.562.541 2.309.884a6.328 6.328 0 0 0 5.219-.169c3.03-1.184 6.079-2.4 9.45-2.107a15.114 15.114 0 0 1 10.688 5.28c.483.569.67 1.014-.188 1.569-8.57 5.547-7.68 18.483.939 23.221 1.251.688 1.492 1.31.932 2.715a39.847 39.847 0 0 1-7.187 11.586c-1.604 1.827-3.623 3.266-6.312 3.121z"
            transform="translate(-302.799 -303.609)"
          />
          <path
            id="Path_3627"
            d="M636.772 422.913c0 3.375-.091 6.341.036 9.3.07 1.629-.786 1.621-1.946 1.609-1.127-.012-1.954.068-1.937-1.588.088-8.694.051-17.389.028-26.084 0-.981.027-1.7 1.344-1.587 1 .088 2.08-.16 1.9 1.444a1.862 1.862 0 0 0 .644 1.627 8.989 8.989 0 0 1 5.773-3.338 8.492 8.492 0 0 1 8.661 4.518c2 3.414 2.009 11.035-1.819 14.5a8.622 8.622 0 0 1-11.738.3c-.178-.155-.384-.286-.946-.701z"
            transform="translate(-502.736 -354.922)"
          />
          <path
            id="Path_3628"
            d="M702.368 423.048c0 3.241-.1 6.222.038 9.192.075 1.644-.795 1.6-1.939 1.605s-1.99.032-1.975-1.6c.075-8.009.034-16.018.033-24.028 0-.559.02-1.119-.008-1.676a1.8 1.8 0 0 1 2.653-1.909c.578.216.494.64.505 1.051.021.718.006 1.437.006 2.209a2.367 2.367 0 0 0 1.6-1.137c3.06-3.644 10.111-3.419 13.081 1.461 2.415 3.969 2.288 10.448-.4 14.078-3.176 4.28-8.392 4.65-13.594.754z"
            transform="translate(-543.845 -354.949)"
          />
          <path
            id="Path_3629"
            d="M557.888 412.387c1.677-5.047 3.331-10.07 5.017-15.083 1.318-3.917 2.856-7.772 3.948-11.75.6-2.183 2-1.658 3.407-1.793s2.048.332 2.512 1.729c2.782 8.367 5.705 16.687 8.5 25.051.181.542 1.249 1.723-.091 1.908-1.124.156-2.831 1.038-3.541-.842a61.335 61.335 0 0 1-2.044-6.136 2.568 2.568 0 0 0-3.145-2.24 53.852 53.852 0 0 1-6.328.018 1.654 1.654 0 0 0-1.983 1.408c-.444 1.73-1.017 3.428-1.585 5.123-1.049 3.127-1.064 3.12-4.667 2.607z"
            transform="translate(-455.69 -342.082)"
          />
          <path
            id="Path_3630"
            d="M795.4 382.874a11.455 11.455 0 0 1 4.621.676c1.36.417.914 1.247.651 2.192-.275.99-.625 1.317-1.651.912a10.154 10.154 0 0 0-5.8-.769c-2 .4-3.592 1.791-3.82 3.309a4.352 4.352 0 0 0 2.554 5.037c2.139 1.1 4.365 2.026 6.491 3.146 3.156 1.662 4.1 4.46 3.74 7.829a7.012 7.012 0 0 1-4.348 5.969c-4.038 1.853-8.055 1.486-12.037-.146-1.618-.663-.388-1.783-.248-2.649.17-1.059.87-.477 1.4-.244a13.254 13.254 0 0 0 5.789 1.044c3.039-.087 5.194-1.362 5.643-3.52.583-2.8-.8-5.144-3.727-6.369-1.593-.667-3.2-1.321-4.744-2.085-3.53-1.743-5.077-4.8-4.309-8.348.692-3.2 4.133-5.9 7.631-5.982.626-.015 1.247-.002 2.164-.002z"
            style={cls2}
            transform="translate(-598.067 -341.51)"
          />
          <path
            id="Path_3631"
            d="M898.059 415.027c.489 7.647-6.879 12.72-14.131 10.025-3.821-1.42-6.179-5.434-6.058-10.487a10.246 10.246 0 0 1 13.1-9.973c4.012 1.068 7.33 4.558 7.089 10.435z"
            transform="translate(-656.308 -354.915)"
          />
          <path
            id="Path_3632"
            d="M988.263 415.75c-1.863 0-3.733.092-5.589-.027-1.7-.109-1.856.762-1.573 2.051a6.6 6.6 0 0 0 6.109 5.053 15.748 15.748 0 0 0 5.515-.57c.639-.2 1.224-.4 1.334.564.08.7.832 1.554-.466 1.963-3.818 1.2-7.631 1.565-11.355-.257a8.182 8.182 0 0 1-4.454-6.047c-.9-4.373-.43-8.446 2.922-11.761a9.3 9.3 0 0 1 9.806-1.9c3.4 1.538 4.834 4.423 4.974 8 .115 2.924.05 2.927-2.937 2.927z"
            style={cls2}
            transform="translate(-718.703 -354.882)"
          />
          <path
            id="Path_3633"
            d="M413.753 294.963c-2.143 0-2.02.011-1.829-2.322.464-5.673 5.612-10.846 11.185-11.931.843-.164 1.517-.34 1.521.951.018 5.672-4.057 11.353-8.936 12.97a4.33 4.33 0 0 1-1.941.332z"
            transform="translate(-364.16 -267.323)"
          />
          <path
            id="Path_3634"
            d="M841.275 405.3c0-1.739-.077-3.481.025-5.214.074-1.263-.4-1.657-1.593-1.525-.963.107-1.765.138-1.753-1.356.012-1.469.681-1.683 1.815-1.519 1.3.188 1.646-.452 1.513-1.6a9.617 9.617 0 0 1-.006-1.116c0-2.018 1.118-3.025 3.153-2.951.7.026.621.459.626.869.018 1.179.062 2.362 0 3.538-.057 1 .351 1.33 1.3 1.263.741-.052 1.492.028 2.234-.018 1.054-.065 1.716.044 1.711 1.44 0 1.325-.528 1.488-1.644 1.486-3.585-.007-3.585.032-3.585 3.564 0 2.794-.011 5.587 0 8.382.012 2.278.836 3.214 3.1 3.077a1.65 1.65 0 0 1 2.026 1.7c.175 1.431-1.073 1.383-1.883 1.5-4.547.644-6.9-1.489-7.033-6.3-.044-1.746-.005-3.485-.006-5.22z"
            style={cls2}
            transform="translate(-631.284 -346.014)"
          />
          <path
            id="Path_3635"
            d="M549.354 317.386c0-2.547.026-5.095-.013-7.641-.014-.908.238-1.21 1.225-1.362a15.687 15.687 0 0 1 9.238.91c3.554 1.638 4.579 5.429 4.245 8.372-.71 6.266-4.47 8.879-10.306 8.709-4.387-.128-4.39-.025-4.39-4.327l.001-4.661z"
            style={cls3}
            transform="translate(-450.331 -294.655)"
          />
          <path
            id="Path_3636"
            d="M948.153 407.944c1.4-1.625 2.594-3.322 4.787-3.666.8-.125 2.179-.8 2.255.895.051 1.121.708 2.635-1.639 2.6-2.647-.042-4.757 2.5-4.792 5.368-.042 3.475-.1 6.953.024 10.424.066 1.853-.984 1.71-2.238 1.778-1.323.072-1.664-.381-1.651-1.673q.1-9.028-.016-18.057c-.014-1 .291-1.224 1.118-1.132s2.025-.427 2.141 1.064c.058.793.011 1.598.011 2.399z"
            style={cls2}
            transform="translate(-698.326 -354.812)"
          />
          <path
            id="Path_3637"
            d="M815.206 323.32c-2.978 2.65-5.569 2.828-7.871.774-2.533-2.261-2.688-6.991-.332-10.181 1.617-2.19 4.663-2.451 7.977-.567 0-2 .035-3.907-.015-5.809-.025-.954.3-1.316 1.278-1.317.938 0 1.315.257 1.308 1.257-.037 5.514-.014 11.029-.024 16.543 0 .52.151 1.083-.752 1.174-1.318.133-1.537-.66-1.569-1.874z"
            style={cls2}
            transform="translate(-610.831 -293.48)"
          />
          <path
            id="Path_3638"
            d="M634.01 332.837c1.045-3.22 2-6.072 2.885-8.947a1.468 1.468 0 0 1 1.523-1.263c1.029-.057 1.034.613 1.233 1.241.906 2.861 1.821 5.72 2.833 8.894.905-3.184 1.739-6.058 2.53-8.943.18-.657.381-1.147 1.184-1.162.949-.017 1.551.008 1.093 1.311-1.2 3.427-2.275 6.9-3.385 10.359-.222.69-.466 1.165-1.377 1.141a1.441 1.441 0 0 1-1.547-1.233c-.856-2.812-1.774-5.606-2.757-8.684-1.006 3.03-1.956 5.785-2.823 8.565-.269.864-.557 1.371-1.611 1.355-1.034-.016-1.182-.635-1.4-1.364-.989-3.3-2.018-6.6-2.973-9.908-.131-.454-.88-1.235.15-1.462.728-.161 1.68-.477 2 .9.685 2.981 1.557 5.918 2.442 9.2z"
            style={cls3}
            transform="translate(-500.295 -303.742)"
          />
          <path
            id="Path_3639"
            d="M980.387 313.924c1.237-.948 2.069-1.7 3.237-1.836a4.653 4.653 0 0 1 5.4 4.748c.1 2.418 0 4.843.032 7.264.011.779-.213 1.1-1.047 1.1s-1.2-.2-1.215-1.133c-.047-2.466.238-4.939-.292-7.4-.408-1.893-1.174-2.74-2.861-2.693a3.121 3.121 0 0 0-3.229 3.119c-.075 2.233-.035 4.47-.014 6.706.008.821-.018 1.436-1.148 1.41-1.039-.024-1.434-.38-1.429-1.424q.043-8.2 0-16.393c0-.913.36-1.162 1.218-1.158.893 0 1.394.188 1.366 1.23-.057 2.036-.018 4.071-.018 6.46z"
            style={cls3}
            transform="translate(-718.976 -293.488)"
          />
          <path
            id="Path_3640"
            d="M861.326 328.47c0-4.156 2.322-6.559 6.324-6.554 4.025 0 6.2 2.408 6.2 6.836a6.3 6.3 0 0 1-6.45 6.6 6.147 6.147 0 0 1-6.074-6.882z"
            style={cls3}
            transform="translate(-645.907 -303.321)"
          />
          <path
            id="Path_3641"
            d="M599.63 321.917c3.847.014 6.188 2.572 6.157 6.726-.028 3.848-2.731 6.767-6.385 6.691-3.318-.07-6.453-2.259-6.2-7.111.198-3.912 2.483-6.323 6.428-6.306z"
            style={cls3}
            transform="translate(-477.82 -303.322)"
          />
          <path
            id="Path_3642"
            d="M747.28 328.531c0 4.079-2.574 6.826-6.39 6.825-3.477 0-6.071-2.9-6.067-6.771 0-4.117 2.4-6.671 6.242-6.669 4.048.003 6.218 2.312 6.215 6.615z"
            style={cls3}
            transform="translate(-566.624 -303.321)"
          />
          <path
            id="Path_3643"
            d="M1020.669 328.876h-2.6c-2.143.009-2.349.354-1.39 2.321.891 1.826 3.34 2.715 6.009 2.108.708-.161 1.5-.753 1.729.435.211 1.118-.856 1.038-1.483 1.169-4.673.976-7.678-.484-8.786-4.393-1.154-4.073 1.385-9.215 6.6-8.689 2.628.265 5.249 3.615 4.655 6.134a1.192 1.192 0 0 1-1.39.929c-1.113-.059-2.229-.015-3.344-.014z"
            style={cls4}
            transform="translate(-741.579 -303.243)"
          />
          <path
            id="Path_3644"
            d="M782.45 329.792c0 1.3.016 2.609-.01 3.913-.008.389.679 1.038-.271 1.12-.543.047-1.383.421-1.592-.427-.257-1.046-.676-.521-1.156-.277a14.317 14.317 0 0 1-1.686.758 3.994 3.994 0 0 1-4.936-1.735 4.2 4.2 0 0 1 1.683-5.336 9.605 9.605 0 0 1 4.441-1.186c1.565-.071 1.484-.792.893-1.782a3.046 3.046 0 0 0-3.684-1.4c-.474.119-.919.35-1.385.5-.51.168-.991.169-1.207-.449a.787.787 0 0 1 .51-1.056 7.507 7.507 0 0 1 6.3-.094c1.752.88 2.023 2.682 2.075 4.466.029.993.005 1.988.005 2.982z"
            style={cls3}
            transform="translate(-590.197 -303.18)"
          />
          <path
            id="Path_3645"
            d="M903.257 323.922c1.8-1.937 3.867-2.57 5.927-1.875 2.118.715 2.886 2.431 2.981 4.444.114 2.412 0 4.835.041 7.252.013.844-.216 1.211-1.144 1.206-.968-.005-1.078-.47-1.109-1.264-.1-2.467.327-4.956-.241-7.4-.474-2.044-1.366-2.745-3.172-2.563a3.489 3.489 0 0 0-2.979 3.248c-.046 2.231-.026 4.463-.005 6.7.007.75-.015 1.279-1.043 1.294-1.053.015-1.187-.43-1.213-1.326-.1-3.392.347-6.8-.3-10.179-.112-.584-.146-1.21.822-1.317 1.295-.15 1.642.458 1.435 1.78z"
            style={cls4}
            transform="translate(-670.776 -303.232)"
          />
          <path
            id="Path_3646"
            d="M685.805 324.041c2.107-2.228 4.174-2.92 6.55-1.808a4.059 4.059 0 0 1 2.3 3.747c.091 2.539.016 5.083.029 7.625 0 .731.016 1.3-1.032 1.309s-1.235-.432-1.216-1.337c.046-2.107.032-4.216.009-6.324-.025-2.228-1.061-3.5-2.861-3.577a3.457 3.457 0 0 0-3.527 3.5c-.073 2.168-.044 4.34-.006 6.509.015.836-.193 1.219-1.13 1.225s-1.129-.395-1.122-1.222c.03-3.286-.018-6.572.038-9.857.01-.6-.518-1.548.75-1.723 1.231-.166 1.136.762 1.218 1.933z"
            style={cls4}
            transform="translate(-534.597 -303.193)"
          />
          <path
            id="Path_3647"
            d="M954.78 322.914c0-1.053-.03-2.107.008-3.159.031-.878.026-1.634-1.209-1.478-.593.075-.7-.353-.692-.841 0-.457.222-.725.667-.683 1.395.134 1.246-.814 1.226-1.688a5.656 5.656 0 0 1 .013-.928c.146-1 .968-.973 1.678-1.007.854-.041.557.7.507 1.049-.275 1.92.26 2.961 2.429 2.569.568-.1 1.146 0 1.094.839-.044.724-.575.789-1.054.689-2.369-.495-2.628.812-2.463 2.681.115 1.291.027 2.6.021 3.9-.007 1.7.316 3.131 2.473 3.11.539-.005.777.26.762.8-.02.723-.552.916-1.09 1.046a3.606 3.606 0 0 1-4.356-3.374c-.075-1.167-.012-2.348-.014-3.525z"
            style={cls3}
            transform="translate(-703.345 -297.812)"
          />
          <path
            id="Path_3648"
            fill="#050505"
            d="M721.861 315.568v-8.012c0-.722-.015-1.326 1.031-1.341s1.219.481 1.215 1.367q-.036 8.2 0 16.4c0 .85-.226 1.208-1.149 1.219-.975.012-1.112-.443-1.1-1.246.02-2.798.004-5.593.003-8.387z"
            transform="translate(-558.49 -293.477)"
          />
          <path
            id="Path_3649"
            d="M643.177 420.03a7.239 7.239 0 0 1 1.33-5.4 5.6 5.6 0 0 1 5.136-2.344 5.748 5.748 0 0 1 5.051 4.25 11.206 11.206 0 0 1-.253 7.714 5.969 5.969 0 0 1-6.456 3.584 5.8 5.8 0 0 1-4.807-5.736c-.005-.557-.001-1.114-.001-2.068z"
            style={cls1}
            transform="translate(-509.128 -359.955)"
          />
          <path
            id="Path_3650"
            d="M708.8 420.393c.061-1.952-.377-4.015 1.128-5.667 1.461-1.605 3.14-2.868 5.474-2.444a5.973 5.973 0 0 1 5 5.024 10.318 10.318 0 0 1-.709 7.364 5.751 5.751 0 0 1-6.332 3.086c-2.985-.728-4.992-3.3-4.575-5.688a9.759 9.759 0 0 0 .014-1.675z"
            style={cls1}
            transform="translate(-550.265 -359.926)"
          />
          <path
            id="Path_3651"
            d="M582.964 392.731c.959 4.557 2.628 8.385 3.885 12.352.254.8-.01.976-.726.972-2.164-.012-4.329 0-6.493-.006-.572 0-.977-.107-.728-.861 1.312-3.981 2.598-7.971 4.062-12.457z"
            style={cls6}
            transform="translate(-468.818 -347.72)"
          />
          <path
            id="Path_3652"
            d="M900.612 419.64a8.362 8.362 0 0 1-1.812 5.922 5.533 5.533 0 0 1-8.295.552c-3.553-3.489-3.248-10.568.568-13.152a5.706 5.706 0 0 1 8.738 2.621 7.255 7.255 0 0 1 .801 4.057z"
            style={cls1}
            transform="translate(-662.672 -359.717)"
          />
          <path
            id="Path_3653"
            fill="#fbfbfb"
            d="M993.118 411.2a5.6 5.6 0 0 1 5.238 4.648c.142.944-.03 1.542-1.214 1.52-2.855-.053-5.712-.034-8.567-.009-1.073.01-1.17-.35-.9-1.355.686-2.604 3.125-4.858 5.443-4.804z"
            transform="translate(-725.075 -359.297)"
          />
          <path
            id="Path_3654"
            d="M555.366 320.367c0-1.921.038-3.843-.014-5.763-.03-1.121.418-1.494 1.529-1.541 4.652-.2 7.418 1.271 8.245 4.849.645 2.787.4 5.652-1.717 7.8-1.859 1.893-4.344 2.272-6.966 1.919-.913-.123-1.1-.516-1.088-1.318.034-1.979.011-3.962.011-5.946z"
            style={cls6}
            transform="translate(-454.099 -297.759)"
          />
          <path
            id="Path_3655"
            d="M818.894 332.071a3.84 3.84 0 0 1-1.1 3.4 3.433 3.433 0 0 1-5.3-.7 6.079 6.079 0 0 1-.3-5.833 3.457 3.457 0 0 1 4.431-2.1 3.039 3.039 0 0 1 2.263 3.568c-.023.371.006.746.006 1.665z"
            style={cls6}
            transform="translate(-614.761 -306.291)"
          />
          <path
            id="Path_3656"
            d="M871.1 336.137a2.685 2.685 0 0 1-2.141-.918 6.047 6.047 0 0 1-.2-7.807 3.419 3.419 0 0 1 5.308.092 6.142 6.142 0 0 1 .013 7.477 3.466 3.466 0 0 1-2.98 1.156z"
            style={cls6}
            transform="translate(-649.763 -306.003)"
          />
          <path
            id="Path_3657"
            d="M603.3 336.069c-2.465.044-4.09-2.08-3.98-5.2.095-2.675 2.02-4.9 4.14-4.784 2.2.121 4.074 2.854 3.752 5.484q-.541 4.44-3.912 4.5z"
            style={cls6}
            transform="translate(-481.664 -305.933)"
          />
          <path
            id="Path_3658"
            d="M748.8 331.146c-.041 2.974-1.679 4.957-4.075 4.932-2.316-.025-3.923-2.049-3.895-4.907.027-2.772 1.919-5.137 4.059-5.075 2.086.062 3.947 2.465 3.911 5.05z"
            style={cls1}
            transform="translate(-570.391 -305.942)"
          />
          <path
            id="Path_3659"
            d="M1023.507 329.871c-.432 0-.867.026-1.3-.006-.6-.045-1.495.285-1.717-.231-.274-.635.217-1.41.642-2.013 1.511-2.14 4.268-2.153 5.483-.043.866 1.5.451 2.265-1.257 2.291-.615.01-1.233.002-1.851.002z"
            style={cls6}
            transform="translate(-745.681 -305.886)"
          />
          <path
            id="Path_3660"
            fill="#fcfcfc"
            d="M784.065 340.637c.011 2.321-1.093 3.554-3.07 3.643a1.977 1.977 0 0 1-2.152-1.087 2.328 2.328 0 0 1 .477-2.717 5.554 5.554 0 0 1 4.066-1.325c1.127-.036.465 1.031.679 1.486z"
            transform="translate(-594.077 -314.127)"
          />
        </g>
      </g>
    </svg>
  );
};

export const GoogleStoreIcon = () => {
  const cls3 = { fill: "#fff" };
  const cls4 = { fill: "#02c5fd" };
  const cls5 = { fill: "#0e7" };

  return (
    <svg width="297.526" height="85.067" viewBox="0 0 297.526 85.067">
      <g id="Group_8374">
        <g id="wirOxh">
          <g id="Group_7945">
            <g id="Group_7944">
              <path
                id="Path_3662"
                fill="#e5e5e5"
                d="M1102.267 481.775c-.536-.22-.354-.439 0-.659z"
                transform="translate(-804.742 -404.077)"
              />
              <path
                id="Path_3663"
                fill="#fefefe"
                d="M1102.451 269.634c-.288-.11-.367-.22 0-.329z"
                transform="translate(-804.925 -262.103)"
              />
              <path
                id="Path_3664"
                d="M348.4 247.47q68.176 0 136.352-.009a13.266 13.266 0 0 1 5.584.952 8.862 8.862 0 0 1 5.491 8.587q.12 33.1.018 66.2a9.219 9.219 0 0 1-8.682 9.208c-.709.061-1.423.093-2.135.093q-136.764.006-273.528.019c-3.435 0-6.5-.68-8.809-3.47a8.574 8.574 0 0 1-2.085-5.582q-.034-33.514.017-67.028c.014-4.779 3.691-8.407 8.79-8.924a22.808 22.808 0 0 1 2.3-.053q68.342.006 136.687.007zm-89.665 33.1c-3.979-2.211-7.975-4.392-11.934-6.638-6.718-3.812-13.458-7.588-20.095-11.538-2.738-1.629-6.068-.813-6.045 3.419.089 16.138.038 32.277.026 48.416a4.48 4.48 0 0 0 1.043 3.164c1.365 1.272 2.482 1.435 4.382.383 4.111-2.276 8.174-4.641 12.271-6.942 5.773-3.242 11.565-6.45 17.339-9.691 4.653-2.612 9.314-5.213 13.929-7.892 3.185-1.849 3.282-4.568.159-6.449-3.631-2.189-7.382-4.168-11.079-6.235zm52.586 16.114c-1.866 0-3.733.04-5.6-.016-.991-.03-1.427.341-1.376 1.323a10.51 10.51 0 0 1 .011 1.469c-.1 1.157.406 1.543 1.54 1.492 1.7-.076 3.4-.021 5.1-.021 3.108 0 3.4.493 1.88 3.274a5.469 5.469 0 0 1-.747 1.065c-3 3.284-6.634 4.141-10.851 2.856a10.415 10.415 0 0 1-6.578-13.841 10.26 10.26 0 0 1 15.926-4.653c.806.587 1.3.549 1.9-.106a9.2 9.2 0 0 1 1.038-1.049c.987-.769.787-1.342-.14-2.025-4.8-3.536-9.964-3.915-15.31-1.626a14.614 14.614 0 0 0-7.98 17.408 15.455 15.455 0 0 0 15.2 10.6 13.127 13.127 0 0 0 12.7-15.16c-.122-.781-.372-1.017-1.119-1-1.866.032-3.732.008-5.598.007zm63.259-1.02a8.083 8.083 0 0 0-11.07.864 9.7 9.7 0 0 0-.66 12.854 8.979 8.979 0 0 0 5.633 3.314 6.612 6.612 0 0 0 6.123-1.824c.557 2.811-.337 5.018-2.342 6.042a4.6 4.6 0 0 1-5.891-1.254c-1.131-1.682-2.176-1.264-3.5-.7-.15.064-.326.065-.474.132-.7.319-.924.671-.495 1.5 2.619 5.071 10.255 6.348 14.356 2.348 2.211-2.156 2.666-4.976 2.725-7.839.1-4.934.046-9.871.009-14.806-.005-.708.457-1.959-.875-1.849-1.206.092-2.934-1.065-3.543 1.215zm39.562 2.682v11.025c0 2.956 0 2.891 2.935 2.948 1.208.023 1.461-.4 1.432-1.5-.069-2.631.017-5.266-.043-7.9-.022-.95.285-1.24 1.214-1.2 1.532.066 3.068.022 4.6.013a8.847 8.847 0 0 0 9.012-8.427 8.754 8.754 0 0 0-8.959-8.818c-2.961.046-5.926.089-8.883-.032-1.2-.049-1.337.4-1.328 1.386.038 4.165.016 8.334.016 12.502zm39.834 2.842a10.734 10.734 0 0 0-6.706-.585c-2.852.679-5.1 2.776-5.414 5.233a5.874 5.874 0 0 0 3.6 6.2 7.106 7.106 0 0 0 8.578-1.577c-.233 1.748.627 2.006 1.846 1.834a2.791 2.791 0 0 1 .82 0c1.194.191 1.616-.218 1.572-1.5-.1-2.954-.028-5.914-.026-8.872 0-4.457-2.054-7.024-6.4-7.99-3.253-.723-7.305.618-8.842 2.954-.277.421-.863 1-.224 1.4a12.669 12.669 0 0 0 2.821 1.224c.841.278.975-.725 1.521-1.032a5.959 5.959 0 0 1 2.774-.876 3.922 3.922 0 0 1 4.077 3.584zm-134.494 2.01a9.261 9.261 0 0 0 9.066 9.6c5.613.078 9.979-3.993 10.044-9.368a9.51 9.51 0 0 0-9.182-9.571c-5.792-.073-9.849 3.741-9.932 9.336zm20.751 0c-.545 5.638 4.593 9.648 9.288 9.607a9.494 9.494 0 0 0 .395-18.982c-5.537-.154-10.187 4.412-9.686 9.377zm56.855 9.592a9.142 9.142 0 0 0 7.218-3.178c.244-.271.633-.747.545-.925-.506-1.018-1.62-1.364-2.477-2-.671-.5-.951.128-1.316.51a5.191 5.191 0 0 1-6.686.925c-.618-.445-1.431-.951-1.4-1.7.032-.794 1.064-.749 1.665-1 3.063-1.292 6.17-2.483 9.217-3.811.452-.2 1.412-.149 1.236-1.195-.515-3.081-4.478-6.461-7.741-6.562-5.68-.174-9.414 3.516-9.572 9.462a9.188 9.188 0 0 0 9.308 9.475zm70.95-6.638a8.969 8.969 0 0 1-.7-1.124c-1.076-2.61-2.131-5.23-3.193-7.846-1.19-2.931-1.19-2.931-4.331-2.808a1.424 1.424 0 0 1-.165 0c-1.164-.089-1.128.508-.766 1.318 2.014 4.506 4.014 9.018 6.037 13.52a3.673 3.673 0 0 1 .224 3.516c-1.122 2.155-2.077 4.4-3.083 6.611-.167.368-.478.793.1 1.132 1.158.681 3.995-.108 4.5-1.282q4.842-11.143 9.666-22.294c1.083-2.511 1.055-2.516-1.668-2.526-1.033 0-2.008-.149-2.5 1.2-1.269 3.458-2.666 6.867-4.124 10.584zm-32.61-7.931c0 4.165.058 8.33-.033 12.493-.03 1.347.42 1.77 1.669 1.575a2.459 2.459 0 0 1 .82 0c1.578.3 1.882-.462 1.871-1.889-.057-7.648-.023-15.3-.025-22.945 0-3.025-.006-2.974-3.04-3.006-1.024-.011-1.3.269-1.284 1.277.051 4.166.019 8.331.019 12.496zm-49.574.261c0-3.729.026-7.459-.008-11.188-.029-3.186.563-2.744-2.922-2.834-.9-.023-1.269.183-1.266 1.15q.04 12.833 0 25.667c0 .791.282 1.091 1.061 1.016a5.994 5.994 0 0 1 1.478 0c1.327.206 1.7-.359 1.677-1.638-.063-4.055-.023-8.114-.023-12.172zm-17.919-33.8c.527.766.8 1.133 1.043 1.521 1.574 2.522 3.174 5.029 4.691 7.585a1.953 1.953 0 0 0 2.214.947c.679-.092.634-.647.634-1.141v-11.508c0-.684-.181-1.161-1.033-1.112-.751.043-1.257.178-1.221 1.11.055 1.421.069 2.848.008 4.269-.054 1.25.24 2.536-.217 3.894-.275-.421-.46-.689-.631-.967q-2.221-3.611-4.44-7.223a2.148 2.148 0 0 0-2.486-1.045c-1.171.258-.719 1.209-.727 1.88-.041 3.452-.008 6.9-.027 10.357 0 .823-.038 1.5 1.126 1.534 1.274.039 1.067-.773 1.068-1.523-.004-2.71-.005-5.419-.005-8.578zm-18.064 3.309c-.434 3.975 3.439 7.122 6.808 7.172a7.172 7.172 0 0 0 7.193-7.24c-.094-4.193-2.98-6.912-7.1-7.141-3.297-.182-7.372 3.118-6.904 7.208zm-49.264-.774v.005c-.767 0-1.538.055-2.3-.014-.881-.08-1.1.26-1.113 1.11s.334 1.009 1.058.971c.928-.048 1.858-.037 2.788-.036.774 0 1.11.2.69 1.079a4.524 4.524 0 0 1-4.059 2.735 4.678 4.678 0 0 1-4.729-2.823 4.912 4.912 0 0 1 .585-5.529 4.7 4.7 0 0 1 6.8-.821c.837.776 1.231.133 1.7-.313.651-.617.035-.96-.376-1.285a6.171 6.171 0 0 0-1.345-.9 7.1 7.1 0 0 0-10.041 6.74 7 7 0 0 0 5.574 6.864c3.223.613 6.308-.261 7.954-4.166 1.059-2.511.384-3.618-2.2-3.617zm5.134.628c0 1.919.036 3.839-.017 5.756-.023.86.266 1.169 1.126 1.152 2.025-.041 4.053-.013 6.079-.012.643 0 1.233-.052 1.233-.925 0-.842-.455-1.166-1.24-1.155-1.151.015-2.309-.055-3.45.059-1.333.133-1.817-.386-1.624-1.667a3.38 3.38 0 0 0 .008-.816c-.095-1 .173-1.531 1.348-1.4a31.013 31.013 0 0 0 3.286.028c.542 0 1-.111 1.008-.786s-.153-1.235-.946-1.273c-.82-.039-1.644-.016-2.466-.016-2.343 0-2.3 0-2.254-2.4.019-.947.352-1.229 1.269-1.178 1.25.07 2.507-.01 3.761.01.786.013 1.274-.265 1.3-1.107.023-.886-.556-1.119-1.289-1.123-1.972-.012-3.943.01-5.914-.013-.9-.011-1.258.348-1.23 1.279.05 1.857.01 3.722.01 5.586zm13.345 1.111h.044c0 1.526.089 3.06-.031 4.576-.082 1.032.358 1.228 1.209 1.248s1.145-.329 1.13-1.18q-.066-3.537 0-7.075c.02-1.024-.429-2.231.26-3.026.557-.643 1.661-.206 2.521-.237.721-.026.931-.393.951-1.045.021-.692-.11-1.223-.936-1.225-2.63-.008-5.26-.02-7.89 0-.757.007-.99.5-.973 1.224a.929.929 0 0 0 .978 1.05 8.94 8.94 0 0 0 1.313-.031c1.1-.1 1.584.235 1.457 1.476a41.859 41.859 0 0 0-.036 4.244zm19.664.01h.01c0 1.481.074 2.967-.025 4.442-.07 1.039.328 1.37 1.288 1.373s1.177-.484 1.166-1.352c-.039-2.854.052-5.71-.044-8.561-.044-1.33.406-1.816 1.684-1.624a7.624 7.624 0 0 0 .821.042c.832.034 1.162-.361 1.177-1.2.016-.9-.4-1.124-1.209-1.109-2.028.036-4.062-.069-6.083.053-.894.054-2.5-.825-2.46 1.126.032 1.741 1.5 1.026 2.369 1.043 1 .02 1.378.291 1.327 1.319-.078 1.482-.024 2.966-.024 4.448zm-5.377-.942v-5.735c0-.678.069-1.321-.958-1.315-.931.006-1.24.383-1.233 1.283q.043 5.658 0 11.316c-.007.836.263 1.175 1.114 1.2.9.027 1.111-.356 1.09-1.179-.051-1.855-.018-3.713-.015-5.57z"
                style={cls3}
                transform="translate(-200.579 -247.461)"
              />
              <path
                id="Path_3667"
                d="M492.216 369.714c1.866 0 3.732.025 5.6-.011.747-.015 1 .222 1.119 1a13.127 13.127 0 0 1-12.7 15.16 15.455 15.455 0 0 1-15.2-10.6 14.614 14.614 0 0 1 7.98-17.408c5.346-2.289 10.514-1.909 15.31 1.626.927.683 1.127 1.257.14 2.025a9.2 9.2 0 0 0-1.038 1.049c-.606.655-1.1.692-1.9.106a10.26 10.26 0 0 0-15.926 4.653 10.415 10.415 0 0 0 6.578 13.841c4.217 1.285 7.852.428 10.851-2.856a5.486 5.486 0 0 0 .747-1.065c1.516-2.781 1.228-3.275-1.88-3.274-1.7 0-3.405-.055-5.1.021-1.135.051-1.643-.335-1.54-1.492a10.5 10.5 0 0 0-.011-1.469c-.051-.982.385-1.353 1.376-1.323 1.861.057 3.728.017 5.594.017z"
                transform="translate(-381.478 -320.494)"
              />
              <path
                id="Path_3668"
                d="M700.135 389.99c.608-2.28 2.337-1.123 3.54-1.222 1.332-.11.87 1.141.875 1.849.037 4.936.094 9.873-.009 14.806-.059 2.863-.515 5.683-2.725 7.839-4.1 4-11.737 2.722-14.356-2.348-.429-.831-.209-1.183.495-1.5.148-.067.325-.068.474-.132 1.322-.56 2.367-.977 3.5.7a4.594 4.594 0 0 0 5.891 1.254c2-1.024 2.9-3.231 2.342-6.042a6.612 6.612 0 0 1-6.123 1.824 8.978 8.978 0 0 1-5.633-3.314 9.7 9.7 0 0 1 .66-12.854 8.084 8.084 0 0 1 11.069-.86zm.511 7.669c-.029-3.227-2.092-5.6-4.891-5.635a5.467 5.467 0 0 0-5.229 5.6c.163 3.583 2.257 5.589 5.331 5.637 2.7.039 4.817-2.535 4.79-5.602z"
                transform="translate(-526.138 -341.79)"
              />
              <path
                id="Path_3669"
                d="M848.255 373.533c0-4.168.022-8.337-.016-12.505-.009-.988.125-1.436 1.328-1.387 2.957.12 5.923.077 8.883.032a8.754 8.754 0 0 1 8.959 8.818 8.847 8.847 0 0 1-9.012 8.427c-1.534.009-3.07.052-4.6-.014-.929-.04-1.236.25-1.214 1.2.059 2.631-.027 5.266.042 7.9.029 1.1-.224 1.528-1.432 1.5-2.934-.057-2.936.008-2.936-2.948zm4.346-5.585c0 1.462.023 2.666-.009 3.869-.017.636.1 1.088.857 1.064 2.019-.062 4.055.236 6.055-.167a4.511 4.511 0 0 0 2.674-7.152c-1.259-1.772-2.983-2-4.9-1.936-1.468.046-3.36-.479-4.3.244-1.095.854-.378 2.53-.378 4.078z"
                transform="translate(-634.696 -322.652)"
              />
              <path
                id="Path_3670"
                d="M944.364 395.256a3.922 3.922 0 0 0-4.078-3.582 5.96 5.96 0 0 0-2.775.876c-.546.308-.68 1.31-1.521 1.032a12.672 12.672 0 0 1-2.821-1.224c-.639-.4-.052-.982.225-1.4 1.537-2.335 5.589-3.677 8.842-2.954 4.342.966 6.4 3.533 6.4 7.99 0 2.958-.074 5.918.026 8.872.044 1.28-.378 1.688-1.572 1.5a2.792 2.792 0 0 0-.82 0c-1.219.172-2.08-.086-1.846-1.834a7.106 7.106 0 0 1-8.578 1.577 5.874 5.874 0 0 1-3.6-6.2c.311-2.457 2.562-4.554 5.413-5.233a10.733 10.733 0 0 1 6.705.58zm-3.467 2.661a4.554 4.554 0 0 0-3.545 1.052 2.1 2.1 0 0 0 .572 3.691 4.535 4.535 0 0 0 4.392-.481c1.1-.841 2.457-1.855 1.93-3.268-.404-1.085-1.996-1.046-3.346-.994z"
                transform="translate(-690.971 -341.532)"
              />
              <path
                id="Path_3671"
                d="M561.19 397.5c.083-5.591 4.14-9.408 9.929-9.343a9.509 9.509 0 0 1 9.182 9.571c-.065 5.375-4.431 9.447-10.044 9.369a9.261 9.261 0 0 1-9.067-9.597zm4.325.052c-.006 3.218 2.144 5.664 5.021 5.711a5.5 5.5 0 0 0 5.417-5.577c-.008-3.142-2.371-5.762-5.288-5.7a5.269 5.269 0 0 0-5.15 5.568z"
                transform="translate(-442.29 -341.768)"
              />
              <path
                id="Path_3672"
                d="M624.048 397.44c-.5-4.963 4.15-9.529 9.683-9.376a9.494 9.494 0 0 1-.395 18.982c-4.695.042-9.836-3.968-9.288-9.606zm4.194.108a5.429 5.429 0 0 0 5.3 5.691 5.71 5.71 0 0 0 5.177-5.754 5.6 5.6 0 0 0-5.328-5.562 5.359 5.359 0 0 0-5.149 5.625z"
                transform="translate(-484.397 -341.703)"
              />
              <path
                id="Path_3673"
                d="M777.633 407.09a9.188 9.188 0 0 1-9.31-9.476c.158-5.946 3.891-9.637 9.572-9.462 3.263.1 7.225 3.481 7.741 6.562.175 1.046-.785 1-1.236 1.195-3.047 1.328-6.153 2.519-9.217 3.811-.6.254-1.633.209-1.665 1-.03.75.782 1.257 1.4 1.7a5.191 5.191 0 0 0 6.686-.925c.365-.382.645-1.008 1.316-.51.857.636 1.971.982 2.477 2 .088.177-.3.654-.545.925a9.143 9.143 0 0 1-7.219 3.18zm3.247-13.624c-.38-.279-.64-.473-.9-.663a4.039 4.039 0 0 0-4.721-.29 5.448 5.448 0 0 0-2.72 4c-.114.625.36.587.738.43q3.357-1.4 6.7-2.841a6.461 6.461 0 0 0 .903-.636z"
                transform="translate(-581.127 -341.76)"
              />
              <path
                id="Path_3674"
                d="M992.689 401.447c1.458-3.717 2.855-7.126 4.122-10.583.495-1.349 1.469-1.2 2.5-1.2 2.723.009 2.751.015 1.668 2.526q-4.812 11.156-9.666 22.294c-.51 1.173-3.347 1.962-4.5 1.282-.576-.339-.265-.764-.1-1.132 1.006-2.214 1.961-4.456 3.083-6.611a3.672 3.672 0 0 0-.224-3.516c-2.023-4.5-4.024-9.014-6.037-13.52-.362-.809-.4-1.406.766-1.318a1.44 1.44 0 0 0 .164 0c3.141-.123 3.142-.123 4.331 2.808 1.062 2.616 2.116 5.236 3.193 7.846a8.993 8.993 0 0 0 .7 1.124z"
                transform="translate(-725.233 -342.755)"
              />
              <path
                id="Path_3675"
                d="M912.781 373.42c0-4.165.031-8.329-.022-12.493-.013-1.009.26-1.288 1.284-1.277 3.035.032 3.04-.019 3.04 3.006 0 7.648-.031 15.3.025 22.945.01 1.427-.294 2.188-1.872 1.889a2.457 2.457 0 0 0-.82 0c-1.249.195-1.7-.229-1.669-1.576.092-4.164.034-8.329.034-12.494z"
                transform="translate(-677.935 -322.659)"
              />
              <path
                id="Path_3676"
                d="M753.965 373.7c0 4.058-.041 8.117.023 12.175.02 1.279-.351 1.844-1.677 1.638a5.991 5.991 0 0 0-1.478 0c-.779.075-1.063-.225-1.061-1.016q.028-12.833 0-25.667c0-.967.367-1.173 1.266-1.15 3.486.091 2.893-.351 2.922 2.835.03 3.722.005 7.452.005 11.185z"
                transform="translate(-568.692 -322.674)"
              />
              <path
                id="Path_3677"
                d="M703.583 292.081v8.578c0 .75.207 1.562-1.068 1.523-1.163-.036-1.13-.711-1.126-1.534.019-3.452-.014-6.905.027-10.357.008-.671-.444-1.622.727-1.88a2.148 2.148 0 0 1 2.486 1.045q2.228 3.606 4.44 7.223c.171.278.356.546.631.967.457-1.358.163-2.644.217-3.894.061-1.42.048-2.847-.008-4.269-.037-.932.469-1.067 1.221-1.11.853-.048 1.033.428 1.033 1.112v11.508c0 .494.045 1.049-.634 1.141a1.953 1.953 0 0 1-2.214-.947c-1.518-2.556-3.117-5.062-4.691-7.585-.24-.387-.514-.755-1.041-1.521z"
                transform="translate(-536.23 -274.861)"
              />
              <path
                id="Path_3678"
                d="M653.286 295.054c-.469-4.086 3.607-7.393 6.9-7.21 4.116.228 7 2.948 7.1 7.141a7.172 7.172 0 0 1-7.193 7.24c-3.368-.049-7.241-3.196-6.807-7.171zm11.754.135c.076-2.98-1.853-5.21-4.556-5.269a4.974 4.974 0 0 0-5.133 4.754c-.093 2.926 1.988 5.4 4.605 5.465a4.842 4.842 0 0 0 5.084-4.95z"
                transform="translate(-503.997 -274.524)"
              />
              <path
                id="Path_3679"
                d="M482.91 294.291h.985c2.587 0 3.262 1.106 2.2 3.617-1.646 3.9-4.731 4.779-7.954 4.166a7 7 0 0 1-5.577-6.864 7.1 7.1 0 0 1 10.042-6.74 6.179 6.179 0 0 1 1.345.9c.41.325 1.026.668.375 1.285-.471.446-.865 1.089-1.7.313a4.7 4.7 0 0 0-6.8.821 4.912 4.912 0 0 0-.585 5.529 4.678 4.678 0 0 0 4.729 2.823 4.523 4.523 0 0 0 4.059-2.735c.42-.876.083-1.078-.69-1.079-.93 0-1.86-.012-2.788.036-.723.038-1.074-.108-1.058-.971s.232-1.19 1.113-1.11c.76.069 1.532.015 2.3.015z"
                transform="translate(-382.885 -274.536)"
              />
              <path
                id="Path_3680"
                d="M519.483 295.313c0-1.864.04-3.729-.017-5.592-.028-.931.327-1.29 1.23-1.279 1.971.023 3.943 0 5.914.013.734 0 1.312.237 1.289 1.123-.022.842-.51 1.12-1.3 1.108-1.253-.02-2.511.059-3.761-.011-.916-.051-1.25.231-1.269 1.178-.048 2.4-.089 2.4 2.254 2.4.822 0 1.646-.023 2.466.016.793.038.956.608.946 1.273s-.466.787-1.008.786a31.022 31.022 0 0 1-3.286-.028c-1.175-.128-1.443.4-1.348 1.4a3.373 3.373 0 0 1-.007.816c-.193 1.281.291 1.8 1.624 1.667 1.14-.114 2.3-.044 3.45-.059.785-.01 1.24.314 1.24 1.155 0 .873-.59.925-1.233.925-2.026 0-4.054-.03-6.079.012-.861.018-1.149-.292-1.126-1.152.057-1.912.021-3.832.021-5.751z"
                transform="translate(-414.324 -274.93)"
              />
              <path
                id="Path_3681"
                d="M552.44 296.441a41.869 41.869 0 0 1 .033-4.24c.127-1.241-.358-1.577-1.457-1.476a8.941 8.941 0 0 1-1.313.031.929.929 0 0 1-.978-1.05c-.017-.725.216-1.217.973-1.224 2.63-.025 5.26-.012 7.89 0 .826 0 .957.534.936 1.225-.019.652-.229 1.019-.951 1.045-.86.031-1.964-.406-2.521.237-.689.795-.24 2-.261 3.026q-.07 3.537 0 7.075c.016.852-.278 1.2-1.13 1.18s-1.291-.217-1.209-1.248c.12-1.517.031-3.05.031-4.576z"
                transform="translate(-433.935 -274.947)"
              />
              <path
                id="Path_3682"
                d="M612.157 296.253c0-1.481-.054-2.965.018-4.443.05-1.028-.328-1.3-1.327-1.319-.872-.017-2.336.7-2.369-1.043-.036-1.951 1.566-1.072 2.46-1.126 2.021-.122 4.055-.017 6.083-.053.812-.014 1.225.213 1.209 1.109-.015.834-.345 1.23-1.177 1.2a7.627 7.627 0 0 1-.821-.043c-1.278-.193-1.729.293-1.684 1.624.1 2.851.005 5.708.044 8.561.012.868-.2 1.356-1.165 1.353s-1.358-.334-1.288-1.373c.1-1.474.025-2.961.025-4.442z"
                transform="translate(-473.989 -274.748)"
              />
              <path
                id="Path_3683"
                d="M598.868 295.494c0 1.857-.034 3.715.014 5.571.021.823-.194 1.206-1.09 1.179-.852-.026-1.121-.366-1.114-1.2q.05-5.658 0-11.316c-.007-.9.3-1.278 1.233-1.283 1.027-.006.96.637.958 1.315-.003 1.911.001 3.822-.001 5.734z"
                transform="translate(-466.078 -274.931)"
              />
              <path
                id="Path_3684"
                d="M709.269 405.453c.027 3.067-2.09 5.645-4.788 5.6-3.074-.048-5.168-2.054-5.331-5.637a5.467 5.467 0 0 1 5.229-5.6c2.798.032 4.861 2.41 4.89 5.637z"
                style={cls3}
                transform="translate(-534.76 -349.584)"
              />
              <path
                id="Path_3685"
                d="M861.12 375.763c.07-3.051-.376-3.285.727-4.137a13.28 13.28 0 0 1 3.954-.184s3.637.164 4.9 1.936a4.511 4.511 0 0 1-2.674 7.152c-2 .4-4.036.105-6.056.167-.757.023-.874-.428-.857-1.064.029-1.204.006-2.408.006-3.87z"
                style={cls3}
                transform="translate(-643.215 -330.466)"
              />
              <path
                id="Path_3686"
                d="M949.647 418.393c1.352-.051 2.945-.091 3.349.994.527 1.412-.833 2.427-1.93 3.268a4.535 4.535 0 0 1-4.392.481 2.1 2.1 0 0 1-.572-3.691 4.554 4.554 0 0 1 3.545-1.052z"
                style={cls3}
                transform="translate(-699.721 -362.008)"
              />
              <path
                id="Path_3687"
                d="M574.291 405.343a5.268 5.268 0 0 1 5.15-5.564c2.917-.064 5.28 2.556 5.288 5.7a5.5 5.5 0 0 1-5.417 5.577c-2.877-.05-5.028-2.496-5.021-5.713z"
                style={cls3}
                transform="translate(-451.066 -349.557)"
              />
              <path
                id="Path_3688"
                d="M636.851 405.4a5.359 5.359 0 0 1 5.149-5.63 5.6 5.6 0 0 1 5.327 5.562 5.71 5.71 0 0 1-5.177 5.754 5.428 5.428 0 0 1-5.299-5.686z"
                style={cls3}
                transform="translate(-493.006 -349.551)"
              />
              <path
                id="Path_3689"
                d="M789.417 401.07a6.439 6.439 0 0 1-.911.641q-3.339 1.44-6.7 2.841c-.378.157-.851.2-.737-.43a5.448 5.448 0 0 1 2.72-4 4.039 4.039 0 0 1 4.721.29c.267.188.527.379.907.658z"
                style={cls3}
                transform="translate(-589.664 -349.365)"
              />
              <path
                id="Path_3690"
                d="M669.306 299.422a4.842 4.842 0 0 1-5.084 4.951c-2.617-.069-4.7-2.539-4.605-5.465a4.973 4.973 0 0 1 5.133-4.754c2.703.058 4.631 2.288 4.556 5.268z"
                style={cls3}
                transform="translate(-508.263 -278.757)"
              />
            </g>
          </g>
        </g>
        <g id="Group_8373" transform="translate(19.907 13.714)">
          <g id="Group_8372">
            <g id="Group_8371">
              <path
                id="Path_3750"
                d="M431.226 564.974a4.335 4.335 0 0 1-1.082-3.433q0-19.053-.01-38.106c0-3.593-.011-7.185 0-10.777a3.275 3.275 0 0 1 .264-1.871c.612.593.4 1.364.4 2.063q.022 15.4.016 30.793a2.653 2.653 0 0 0 .26 1.708c.546-.329.385-.784.385-1.188 0-1.283.243-1.668 1.478-1.776a2.492 2.492 0 0 0 2.313-1.516 1.981 1.981 0 0 1 1.752-1.119c.622-.065 1.26-.258 1.424-.913a4.965 4.965 0 0 1 2.157-2.781c2.519-1.816 4.277-4.413 6.671-6.356a8.358 8.358 0 0 1 2.779-1.245c.706-.24 1.116.5 1.638.831 2.291 2.164 4.593 4.319 6.866 6.5.423.407.919.8.893 1.484-.138.748-.8 1.083-1.257 1.574-2.686 2.878-5.681 5.442-8.426 8.263-3.43 3.526-6.952 6.961-10.457 10.412-2.408 2.371-4.718 4.843-7.289 7.045a1.184 1.184 0 0 1-.775.408z"
                style={cls4}
                transform="translate(-430.125 -508.39)"
              />
              <path
                id="Path_3751"
                d="M452.593 520.834l-.127-.015c-.726-.089-1.047-1.521-2.138-.547-.584.521-1.467.443-2.16 1.125-1.294 1.274-2.508 2.6-3.758 3.907a41.132 41.132 0 0 1-3.8 3.183 1.749 1.749 0 0 0-.8 1.237c-.054 1.238-.829 1.64-1.869 1.625a1.487 1.487 0 0 0-1.644 1.122 1.993 1.993 0 0 1-2.234 1.479c-1.395.015-1.583.276-1.328 1.587.008.041.037.079.043.12.113.753-.122 1.586-.817 1.648-.759.067-.657-.821-.657-1.4q-.007-16.171-.008-32.342c0-.513-.025-1.025-.039-1.538a2.05 2.05 0 0 1 .752-1.541c.644-.291.927.3 1.341.712 3.685 3.687 7.271 7.478 11.095 11.021 2.539 2.352 4.86 4.915 7.392 7.269.368.35.923.662.756 1.348z"
                style={cls4}
                transform="translate(-431.101 -499.366)"
              />
              <path
                id="Path_3752"
                d="M437.523 493.965l-.523-.392c1.025-1.311 2.364-1.438 4.113-.539 2.542 1.307 5.028 2.723 7.523 4.119q12.627 7.063 25.241 14.148c.333.187.642.417.962.627-.2 1.318-1.36 1.911-2.173 2.711-2.307 2.269-4.579 4.575-6.914 6.817-.2.116-.143.111-.377-.16-.703-1.143-27.695-27.213-27.852-27.331z"
                style={cls5}
                transform="translate(-436.101 -492.455)"
              />
              <path
                id="Path_3753"
                fill="#fe3a46"
                d="M466.114 710.878c.159-.036-.184.018-.026-.018.78.382 9.388 9.158 9.31 9.826-6.648 3.757-13.348 7.151-20 10.9q-6.629 3.732-13.285 7.414c-1.919 1.058-3.311.945-4.563-.244l13.579-13.366c4.583-4.514 14.743-14.216 14.985-14.512z"
                transform="translate(-436.577 -682.3)"
              />
              <path
                id="Path_3754"
                fill="#fecc01"
                d="M663.49 660.3q-4.185-4.2-8.375-8.387c-.331-.33-.788-.853-1.115-1.18 1.308-1.569 2.812-2.572 4.09-3.925 1.751-1.854 3.733-3.48 5.374-5.442 3.873 2.156 7.8 4.221 11.6 6.5 2.818 1.689 2.756 4.385-.079 6.036-3.785 2.207-7.659 4.272-11.495 6.398z"
                transform="translate(-624.725 -621.893)"
              />
              <path
                id="Path_3755"
                d="M430.13 505.06s.06-1.942.695-2.247"
                style={cls4}
                transform="translate(-430.129 -501.459)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PhoneIcon = () => {
  return (
    <svg width="54.751" height="115.149" viewBox="0 0 54.751 115.149">
      <g>
        <g>
          <g fill="#fff">
            <path
              d="M279.081 343.825q0 21.563-.007 43.126c0 2.075.031 4.161-.158 6.223a9.449 9.449 0 0 1-9.366 8.508q-16.376.024-32.753-.007a24.989 24.989 0 0 1-5.264-.344 9.416 9.416 0 0 1-7.083-8.522c-.109-2.02-.1-4.047-.1-6.071q-.01-26.086 0-52.172c0-3.3.059-6.592.055-9.888q-.016-14-.059-27.993a9.846 9.846 0 0 1 7.227-9.843 10.309 10.309 0 0 1 2.467-.281q17.7-.026 35.405-.01a9.6 9.6 0 0 1 9.6 9.327c.092 3.949.028 7.9.029 11.853v15.909zM227.125 345v42.1a1.062 1.062 0 0 0 1.186 1.2c.934.012 1.868.007 2.8 0 4.753-.013 9.507-.038 14.26-.041q14.581-.01 29.16 0a5.87 5.87 0 0 0 .779-.014 1.019 1.019 0 0 0 .986-1.017c.019-.285.018-.571.018-.857v-62.912-20.428c0-1.226-.286-1.5-1.524-1.5q-9.251-.007-18.5-.009-13.712 0-27.425.008c-1.522 0-1.733.216-1.733 1.771V345zm24.513 54.243a3.89 3.89 0 1 0-3.817-4.006 3.889 3.889 0 0 0 3.817 4.005zM248.477 295.2v.066a4.281 4.281 0 0 0-1.085.021 2.932 2.932 0 0 0-.782.525c.245.172.488.49.735.493 2.9.034 5.807.021 8.711.021.424 0 .873-.086.745-.612a1 1 0 0 0-.788-.491c-2.513-.043-5.024-.023-7.536-.023zm3.244-4.807a1.194 1.194 0 0 0 0 2.387 1.194 1.194 0 0 0 0-2.387zm-8.6 6.466l.367.014a3.765 3.765 0 0 0 .74-.988c.15-.467-.371-.963-.883-.942-.551.022-.942.357-.872.875.049.365.419.691.647 1.036z"
              transform="translate(-224.348 -286.546) translate(224.348 286.546) translate(-224.348 -286.546)"
            />
            <path
              d="M228.619 353.068v-41.694c0-1.555.211-1.77 1.733-1.771q13.713 0 27.425-.008 9.251 0 18.5.009c1.238 0 1.523.279 1.524 1.5v83.34c0 .286 0 .573-.018.857a1.019 1.019 0 0 1-.986 1.017 5.875 5.875 0 0 1-.779.014h-29.16c-4.753 0-9.507.028-14.26.041-.934 0-1.868.007-2.8 0a1.062 1.062 0 0 1-1.186-1.2v-42.1z"
              opacity="0.532"
              transform="translate(-224.348 -286.546) translate(224.348 286.546) translate(-225.842 -294.615)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RedQuestionMark = () => {
  return (
    <svg width="26" height="24" viewBox="0 0 26 24">
      <g>
        <g>
          <path
            fill="#b44d4d"
            d="M10.362 4.87a3 3 0 0 1 5.276 0l7.963 14.7A3 3 0 0 1 20.963 24H5.037A3 3 0 0 1 2.4 19.571z"
            transform="translate(-746.3 -447.39) translate(746.301 447.103) translate(-.001 .287)"
          />
          <text
            fill="#fff"
            fontFamily="NiveauGroteskBold, Niveau Grotesk"
            fontSize="15px"
            transform="translate(-746.3 -447.39) translate(746.301 447.103) translate(.999 6.287)"
          >
            <tspan x="9.953" y="14">
              !
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
};

export const PhoneEnvelopeIcon = () => {
  const style = {
    fill: "#fff",
  };
  return (
    <svg width="54.751" height="115.149" viewBox="0 0 54.751 115.149">
      <g id="Group_11892" transform="translate(-818.501 -418.926)">
        <g id="Group_11890" transform="translate(594.152 132.38)">
          <g id="Group_11889" transform="translate(224.348 286.546)">
            <g id="Group_11888">
              <path
                id="Path_5294"
                d="M279.081 343.825q0 21.563-.007 43.126c0 2.075.031 4.161-.158 6.223a9.449 9.449 0 0 1-9.366 8.508q-16.376.024-32.753-.007a24.989 24.989 0 0 1-5.264-.344 9.416 9.416 0 0 1-7.083-8.522c-.109-2.02-.1-4.047-.1-6.071q-.01-26.086 0-52.172c0-3.3.059-6.592.055-9.888q-.016-14-.059-27.993a9.846 9.846 0 0 1 7.227-9.843 10.309 10.309 0 0 1 2.467-.281q17.7-.026 35.405-.01a9.6 9.6 0 0 1 9.6 9.327c.092 3.949.028 7.9.029 11.853v15.909zM227.125 345v42.1a1.062 1.062 0 0 0 1.186 1.2c.934.012 1.868.007 2.8 0 4.753-.013 9.507-.038 14.26-.041q14.581-.01 29.16 0a5.87 5.87 0 0 0 .779-.014 1.019 1.019 0 0 0 .986-1.017c.019-.285.018-.571.018-.857v-62.912-20.428c0-1.226-.286-1.5-1.524-1.5q-9.251-.007-18.5-.009-13.712 0-27.425.008c-1.522 0-1.733.216-1.733 1.771V345zm24.513 54.243a3.89 3.89 0 1 0-3.817-4.006 3.889 3.889 0 0 0 3.817 4.005zM248.477 295.2v.066a4.281 4.281 0 0 0-1.085.021 2.932 2.932 0 0 0-.782.525c.245.172.488.49.735.493 2.9.034 5.807.021 8.711.021.424 0 .873-.086.745-.612a1 1 0 0 0-.788-.491c-2.513-.043-5.024-.023-7.536-.023zm3.244-4.807a1.194 1.194 0 0 0 0 2.387 1.194 1.194 0 0 0 0-2.387zm-8.6 6.466l.367.014a3.765 3.765 0 0 0 .74-.988c.15-.467-.371-.963-.883-.942-.551.022-.942.357-.872.875.049.365.419.691.647 1.036z"
                style={style}
                transform="translate(-224.348 -286.546)"
              />
              <path
                id="Path_5295"
                fill="#fff"
                d="M228.619 353.068v-41.694c0-1.555.211-1.77 1.733-1.771q13.713 0 27.425-.008 9.251 0 18.5.009c1.238 0 1.523.279 1.524 1.5v83.34c0 .286 0 .573-.018.857a1.019 1.019 0 0 1-.986 1.017 5.875 5.875 0 0 1-.779.014h-29.16c-4.753 0-9.507.028-14.26.041-.934 0-1.868.007-2.8 0a1.062 1.062 0 0 1-1.186-1.2v-42.1z"
                opacity="0.532"
                transform="translate(-225.842 -294.615)"
              />
            </g>
          </g>
        </g>
        <g id="Group_11891" transform="translate(0 -7.522)">
          <g id="Group_7424" transform="translate(830.492 472.484)">
            <path
              id="Path_3437"
              d="M240.583 762.523c-7.975-5.788-8.582-6.3-10.42-7.735a1.445 1.445 0 0 1-.553-1.135v-1.142a2.885 2.885 0 0 1 2.884-2.885h25a2.885 2.885 0 0 1 2.885 2.885v1.142a1.436 1.436 0 0 1-.553 1.135c-1.838 1.442-2.445 1.947-10.42 7.735-1.009.733-3.016 2.511-4.411 2.488-1.395.023-3.403-1.756-4.412-2.488zm19.8-4.994v12.29a2.885 2.885 0 0 1-2.885 2.884h-25a2.885 2.885 0 0 1-2.884-2.884v-12.284a.36.36 0 0 1 .583-.283c1.346 1.045 3.13 2.374 9.26 6.827 1.268.925 3.408 2.872 5.541 2.861 2.146.017 4.327-1.972 5.546-2.861 6.13-4.453 7.909-5.786 9.255-6.833a.363.363 0 0 1 .579.283z"
              style={style}
              transform="translate(-229.609 -749.626)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RightWhiteArrow = () => {
  return (
    <svg width="18.592" height="19.532" viewBox="0 0 18.592 19.532">
      <g>
        <path
          fill="#fff"
          d="M19.068 7.685l-.94-.94a1.605 1.605 0 0 0-1.141-.464 1.536 1.536 0 0 0-1.129.464l-3.686 3.686V1.6A1.542 1.542 0 0 0 11.7.476 1.542 1.542 0 0 0 10.569 0h-1.6a1.542 1.542 0 0 0-1.133.476A1.542 1.542 0 0 0 7.359 1.6v8.826L3.673 6.745a1.536 1.536 0 0 0-1.128-.464 1.605 1.605 0 0 0-1.145.464l-.928.94A1.556 1.556 0 0 0 0 8.826a1.49 1.49 0 0 0 .476 1.128l8.161 8.174a1.536 1.536 0 0 0 1.128.464 1.6 1.6 0 0 0 1.141-.464l8.162-8.174a1.536 1.536 0 0 0 .464-1.128 1.605 1.605 0 0 0-.464-1.141z"
          transform="rotate(-90 9.296 9.296)"
        />
      </g>
    </svg>
  );
};

export const WhiteIIcon = () => {
  const style = {
    fill: "#555",
  };
  return (
    <svg
      id="Group_11698"
      width="31.37"
      height="31.36"
      viewBox="0 0 31.37 31.36"
    >
      <g id="Group_8536">
        <path
          id="Path_3766"
          fill="#fff"
          d="M538.212 1130.56c9.058 0 15.672 6.565 15.692 15.578.019 9.221-6.618 15.819-15.878 15.782-8.972-.035-15.51-6.694-15.492-15.777.018-9.01 6.63-15.582 15.678-15.583z"
          transform="translate(-522.534 -1130.56)"
        />
        <g id="Group_8542" transform="translate(13.045 6.26)">
          <path
            id="Path_3767"
            d="M630.144 1247.689c-.009 1.75-1.064 2.133-2.591 2.121-1.448-.011-2.293-.552-2.333-2.045-.049-1.85-.07-3.69-.032-5.552.039-1.887.294-2.962 2.452-2.962 2.142 0 2.524 1.069 2.524 2.886"
            style={style}
            transform="translate(-624.968 -1231.941)"
          />
          <path
            id="Path_3768"
            d="M623.357 1175.54a2.708 2.708 0 1 1 2.629 2.995c-1.543-.022-2.604-.971-2.629-2.995z"
            style={style}
            transform="translate(-623.357 -1172.971)"
          />
        </g>
      </g>
    </svg>
  );
};

export const IntroductionCloseX = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="81.788"
      height="81.788"
      viewBox="0 0 81.788 81.788"
    >
      <defs>
        <filter
          id="7s54454gya"
          width="81.788"
          height="81.788"
          x="0"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur result="blur" stdDeviation="3" />
          <feFlood floodOpacity=".161" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g>
        <g
          filter="url(#7s54454gya)"
          transform="rotate(45 13.204 52.363) rotate(-45 13.146 52.15)"
        >
          <rect
            width="45.105"
            height="45.105"
            fill="#fff"
            rx="22.552"
            transform="rotate(45 13.202 52.359)"
          />
        </g>
        <g>
          <path
            fill="#787878"
            d="M27.32 11.558a2.1 2.1 0 0 1 2.1 2.1v2.1a2.1 2.1 0 0 1-2.1 2.1h-9.457v9.462a2.1 2.1 0 0 1-2.1 2.1h-2.1a2.1 2.1 0 0 1-2.1-2.1v-9.457H2.1a2.1 2.1 0 0 1-2.1-2.1v-2.1a2.1 2.1 0 0 1 2.1-2.1h9.457V2.1a2.1 2.1 0 0 1 2.1-2.1h2.1a2.1 2.1 0 0 1 2.1 2.1v9.456z"
            transform="rotate(45 13.204 52.363) translate(7.683 7.683)"
          />
        </g>
      </g>
    </svg>
  );
};

export const PhoneWhiteIcon = () => {
  return (
    <svg width="46.028" height="96.802" viewBox="0 0 46.028 96.802">
      <g>
        <g>
          <g>
            <g fill="#fff">
              <path
                d="M270.36 334.7q0 18.128-.005 36.255c0 1.744.026 3.5-.133 5.231a7.944 7.944 0 0 1-7.873 7.153q-13.767.02-27.534-.006a21 21 0 0 1-4.425-.289 7.916 7.916 0 0 1-5.955-7.164c-.092-1.7-.081-3.4-.081-5.1q-.008-21.929 0-43.859c0-2.771.049-5.542.046-8.313q-.013-11.767-.05-23.533a8.277 8.277 0 0 1 6.075-8.275 8.665 8.665 0 0 1 2.074-.236q14.882-.022 29.764-.008a8.067 8.067 0 0 1 8.072 7.841c.077 3.32.023 6.643.025 9.965v13.374zm-43.677.987v35.394a.892.892 0 0 0 1 1.012c.785.01 1.57.006 2.355 0 4-.011 7.992-.032 11.988-.034q12.257-.008 24.514 0a4.929 4.929 0 0 0 .655-.011.857.857 0 0 0 .829-.855c.016-.239.015-.48.015-.721v-52.888-17.173c0-1.03-.24-1.264-1.281-1.265q-7.777-.006-15.554-.008-11.527 0-23.056.007c-1.28 0-1.457.181-1.457 1.489v35.051zm20.607 45.6a3.27 3.27 0 1 0-3.209-3.368 3.269 3.269 0 0 0 3.209 3.366zm-2.657-87.468v.055a3.6 3.6 0 0 0-.912.018 2.463 2.463 0 0 0-.658.441c.206.144.41.412.618.414 2.441.029 4.882.018 7.323.017.356 0 .734-.073.626-.514a.842.842 0 0 0-.662-.413c-2.113-.037-4.224-.02-6.335-.02zm2.727-4.041a1 1 0 0 0 0 2.007 1 1 0 0 0 0-2.007zm-7.231 5.436l.308.012a3.164 3.164 0 0 0 .622-.83c.126-.393-.312-.81-.742-.792-.463.019-.792.3-.733.736.042.308.353.581.545.872z"
                transform="translate(-224.348 -286.546)"
              />
              <path
                d="M228.618 347.1v-35.97c0-1.342.182-1.527 1.5-1.528q11.849 0 23.7-.007 7.993 0 15.986.008c1.07 0 1.316.24 1.317 1.3v71.901c0 .247 0 .494-.016.74a.88.88 0 0 1-.852.877 5.079 5.079 0 0 1-.673.012h-25.2c-4.107 0-8.214.024-12.321.035-.807 0-1.614.006-2.421 0a.917.917 0 0 1-1.025-1.039v-36.323z"
                opacity="0.999"
                transform="translate(-226.509 -298.135)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const EnvelopeIcon = () => {
  return (
    <svg width="67.858" height="50.894" viewBox="0 0 67.858 50.894">
      <g>
        <g>
          <path
            fill="#fff"
            d="M253.811 778.069c-17.589-12.764-18.928-13.891-22.981-17.058a3.188 3.188 0 0 1-1.22-2.5v-2.518a6.364 6.364 0 0 1 6.361-6.362h55.135a6.364 6.364 0 0 1 6.362 6.362v2.518a3.167 3.167 0 0 1-1.221 2.5c-4.053 3.181-5.393 4.294-22.981 17.058-2.225 1.616-6.652 5.539-9.728 5.487-3.076.051-7.502-3.872-9.727-5.487zm43.656-11.014v27.1a6.363 6.363 0 0 1-6.362 6.361H235.97a6.363 6.363 0 0 1-6.361-6.361v-27.09a.793.793 0 0 1 1.287-.624c2.968 2.305 6.9 5.235 20.421 15.056 2.8 2.041 7.516 6.334 12.221 6.309 4.733.039 9.543-4.349 12.232-6.309 13.518-9.822 17.442-12.762 20.41-15.07a.8.8 0 0 1 1.287.628z"
            transform="translate(-229.609 -749.626)"
          />
        </g>
      </g>
    </svg>
  );
};

export const LeftArrow = () => {
  return (
    <svg width="16.626" height="28.51" viewBox="0 0 16.626 28.51">
      <path
        fill="#fff"
        d="M0 14.255a.9.9 0 0 1 .285-.655L13.6.286a.9.9 0 0 1 1.314 0l1.429 1.428a.9.9 0 0 1 0 1.314L5.114 14.255l11.227 11.227a.9.9 0 0 1 0 1.314l-1.429 1.429a.9.9 0 0 1-1.314 0L.285 14.912A.906.906 0 0 1 0 14.255"
      />
    </svg>
  );
};
